import {useApiCreate} from "../../../../../lib/HttpService";
import {PATH} from "./const";
import {StubbornService} from "../../../../../application/business/StubbornAsset";

export const useEditionServiceCreate = () => useApiCreate<StubbornService>(PATH);
